import {Component} from '@angular/core';
import {FieldType} from '@ngx-formly/core';

@Component({
  selector: 'formly-field-editor',
  template: `
    <editor [formControl]="formControl"
            [formlyAttributes]="field"
            [init]="{
                     base_url: '/tinymce',
                     suffix: '.min',
                     height: 300,
                     menubar: false,
                     statusbar: false,
                     resize: false,
                     branding: false,
                     elementpath: false,
                     plugins: [
                       'advlist autolink lists link image charmap print preview anchor',
                       'searchreplace visualblocks code fullscreen',
                       'insertdatetime media table paste code help'
                     ],
                     toolbar: 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | removeformat | image link | help'
                   }"
    ></editor>
  `,
})
export class FormlyFieldEditor extends FieldType {
}
